function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#33D5BA",
  d: "M33.771 14.281H16.23c-.256 0-.51.05-.746.148-.236.098-.451.242-.632.423-.181.18-.325.396-.423.632-.098.237-.148.49-.148.746v17.541c0 .256.05.51.148.746.098.237.242.452.423.633.18.18.396.324.632.422.236.098.49.148.746.148h17.541c.256 0 .51-.05.746-.148.236-.098.451-.241.633-.422.18-.181.324-.396.422-.633.098-.236.148-.49.148-.746v-17.54c0-.257-.05-.51-.148-.747-.098-.236-.242-.451-.422-.632-.182-.181-.396-.325-.633-.423-.236-.098-.49-.148-.746-.148zM32.35 30.847h-5.78v-.324l1.354-1.19v-6.8L24.6 30.843h-.519l-3.709-8.378v5.935l1.7 2.121v.324h-4.421v-.324l1.753-2.12v-7.058l-1.558-1.948v-.238h4.264l3.312 7.165 2.859-7.165h4.048v.238l-1.48 1.244v8.691l1.5 1.191.001.325z"
});
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.76760b5e605ef98729b825d6eb2394c1.svg";
export { ForwardRef as ReactComponent };